<template>
  <div v-if="loaded" class="settings-card">
    <div class="settings-card__header">
      <div class="settings-card__title">{{ $t('notifications.header') }}</div>
      <div class="settings-card__subtitle">{{ $t('notifications.description') }}</div>
    </div>

    <b-alert :show="showError" variant="danger" dismissible class="mb-3" @dismissed="showError = false">
      {{ $t('notifications.saveError') }}
    </b-alert>

    <!-- Master switch -->
    <div class="notif-row">
      <b-form-checkbox switch v-model="notifications.notificationActive" class="notif-switch"></b-form-checkbox>
      <span class="notif-label notif-label--master">{{ $t('notifications.sendNotifications') }}</span>
    </div>

    <!-- Children: disabled (and dimmed) until the master switch is on -->
    <div class="notif-row notif-row--child" :class="{ 'is-disabled': !notifications.notificationActive }">
      <b-form-checkbox
        switch
        v-model="notifications.dailyNotificationActive"
        :disabled="!notifications.notificationActive"
        class="notif-switch"
      ></b-form-checkbox>
      <span class="notif-label">{{ $t('notifications.dailyOfFollowed') }}</span>
    </div>

    <div class="notif-row notif-row--child" :class="{ 'is-disabled': !notifications.notificationActive }">
      <b-form-checkbox
        switch
        v-model="notifications.weeklyNotificationActive"
        :disabled="!notifications.notificationActive"
        class="notif-switch"
      ></b-form-checkbox>
      <span class="notif-label">{{ $t('notifications.weeklyReport') }}</span>
    </div>

    <div v-if="notifications.weeklyNotificationActive" class="notif-row notif-row--child notif-multiselect">
      <custom-multi-select
        :disabled="!notifications.notificationActive"
        :options="issuers"
        v-model="notifications.weeklyNotificationIssuers"
        use-ticks
        show-clear-selection
        show-count
        show-all
        :default-text="$t('notifications.allMarket')"
        :select-all-text="$t('notifications.allMarket')"
        :multiple="true"
      >
      </custom-multi-select>
    </div>

    <div class="settings-card__footer">
      <b-button @click="save" variant="primary" :disabled="showSaving" size="sm">{{ $t('notifications.save') }}</b-button>
    </div>
  </div>
</template>

<script>
import CustomMultiSelect from '../../components/Lib/CustomMultiSelect'

export default {
  name: 'Notifications',
  components: { CustomMultiSelect },
  data() {
    return {
      loaded: false,
      issuers: {},
      notifications: {
        notificationActive: false,
        dailyNotificationActive: false,
        weeklyNotificationActive: false,
        weeklyNotificationIssuers: [],
      },
      showSaving: false,
      showError: false,
    }
  },
  methods: {
    save() {
      this.showSaving = true
      this.showError = false
      this.post('/api/user/notification', this.notifications)
        .then(() => {
          this.showSaving = false
        })
        .catch(() => {
          // OKV-240: in-app feedback instead of a native alert().
          this.showSaving = false
          this.showError = true
        })
    },
  },
  mounted() {
    this.get('/api/user/notification', {}).then((resp) => {
      if (resp != null && resp.notificationActive != null) {
        if (resp.weeklyNotificationIssuers == null) {
          resp.weeklyNotificationIssuers = []
        }
        this.notifications = resp
        this.issuers = {}
        resp.issuers.forEach((el) => (this.issuers[el.code] = el.name))
        this.loaded = true
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.settings-card {
  background: #fff;
  border: 1px solid #e6e8eb;
  border-radius: 10px;
  padding: 20px 24px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}
.settings-card__header {
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #ededf1;
}
.settings-card__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2430;
}
.settings-card__subtitle {
  margin-top: 4px;
  font-size: 0.875rem;
  color: #8a93a2;
}

.notif-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
}
.notif-row--child {
  padding-left: 2.25rem;
}
.notif-row.is-disabled .notif-label {
  color: #b7bdc7;
}
.notif-label {
  font-size: 0.9rem;
  color: #3b4452;
}
.notif-label--master {
  font-weight: 700;
  color: #1f2430;
}
.notif-switch {
  margin: 0;
}
.notif-multiselect {
  display: block;
  padding-top: 0;
  max-width: 540px;
}

.settings-card__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 16px;
  margin-top: 6px;
  border-top: 1px solid #ededf1;
}
</style>
